import {
  FINANCE_SLICERS,
  PAGE_SLICERS,
  type FinanceSlicerKey,
} from "../lib/finance";
import { useStore } from "../store";

const LABEL_OF = new Map<FinanceSlicerKey, string>(
  FINANCE_SLICERS.map((s) => [s.key, s.label]),
);

/**
 * The slicer grid, shared across the report's three pages.
 *
 * Each page shows exactly the slicers the source report carries -- Payout has
 * `Type` but no tax segment, Taxes the reverse, Deferred has Subscription
 * Length. The state itself is shared, so a filter set on one page survives a
 * move to another that also carries it.
 *
 * `plan_name` is deliberately absent: ~150k distinct values would ship 150k
 * rows to the client just to populate a dropdown.
 */
export function FilterBar() {
  const page = useStore((s) => s.page);
  const filters = useStore((s) => s.filters);
  const opts = useStore((s) => s.slicerOptions);
  const setFilter = useStore((s) => s.setFilter);

  const keys = PAGE_SLICERS[page];
  const active = keys.some((k) => !!filters[k]);

  return (
    <div className="filterbar finance">
      <span className="filterbar-title">Filters</span>

      {keys.map((key) => (
        <label className="slicer compact" key={key}>
          <span>{LABEL_OF.get(key)}</span>
          <select
            value={filters[key] ?? ""}
            onChange={(e) => setFilter({ [key]: e.target.value || undefined })}
          >
            <option value="">All</option>
            {opts[key].map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </select>
        </label>
      ))}

      {active && (
        <button
          className="btn ghost slim"
          onClick={() =>
            setFilter(
              Object.fromEntries(keys.map((k) => [k, undefined])) as Record<
                FinanceSlicerKey,
                undefined
              >,
            )
          }
        >
          Reset
        </button>
      )}
    </div>
  );
}
